/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PatientBehaviorResponseModel } from '../../models/patient-behavior-response-model';

export interface GetPatientBehaviorResponses$Params {
  onlyActive?: boolean;
}

export function GetPatientBehaviorResponses(http: HttpClient, rootUrl: string, params?: GetPatientBehaviorResponses$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PatientBehaviorResponseModel>>> {
  const rb = new RequestBuilder(rootUrl, GetPatientBehaviorResponses.PATH, 'get');
  if (params) {
    rb.query('onlyActive', params.onlyActive, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<PatientBehaviorResponseModel>>;
    })
  );
}

GetPatientBehaviorResponses.PATH = '/api/Staff/GetPatientBehaviorResponses';
